import { render, staticRenderFns } from "./OcrFormField.vue?vue&type=template&id=ad97a384"
import script from "./OcrFormField.vue?vue&type=script&lang=js"
export * from "./OcrFormField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports